const Utils = {};

/**
 * parse query string paramters from 'str' or loaction.search
 * @param  {String} str
 * @return {Object}
 */
Utils.getQueryParameters = function (str) {
  var q = str || document.location.search;
  if (!q) return {};
  return q
    .replace(/(.*\?)?/, '')
    .split('&')
    .reduce(function (prev, curr) {
      var kv = curr.split('=');
      prev[kv[0]] = kv[1];
      return prev;
    }, {});
};
Utils.detectIE = function () {
  var ua = navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // IE 12 => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};

Utils.arrayToUTF = function (array) {
  let out, i, len, c;
  let char2, char3;

  out = '';
  len = array.length;
  i = 0;
  while (i < len) {
    c = array[i++];
    // eslint-disable-next-line default-case
    switch (c >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        // 0xxxxxxx
        out += String.fromCharCode(c);
        break;
      case 12:
      case 13:
        // 110x xxxx   10xx xxxx
        char2 = array[i++];
        out += String.fromCharCode(((c & 0x1f) << 6) | (char2 & 0x3f));
        break;
      case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
        char2 = array[i++];
        char3 = array[i++];
        out += String.fromCharCode(((c & 0x0f) << 12) | ((char2 & 0x3f) << 6) | ((char3 & 0x3f) << 0));
        break;
    }
  }

  return out;
};

// /**
//  * writes string to byte array in utf
//  * @param {string} str string to write
//  * @param {boolean} withLength flag, write array length at start
//  * @param {integer} length length bytes count to write
//  */
Utils.UTFtoArray = function (str, withLength, sizeBytesLength) {
  const r = [];
  for (let n = 0; n < str.length; n++) {
    const c = str.charCodeAt(n);
    if (c < 128) {
      r.push(c);
    } else if (c > 127 && c < 2048) {
      r.push((c >> 6) | 192);
      r.push((c & 63) | 128);
    } else {
      r.push((c >> 12) | 224);
      r.push(((c >> 6) & 63) | 128);
      r.push((c & 63) | 128);
    }
  }
  if (withLength) {
    if (!sizeBytesLength) {
      sizeBytesLength = 2;
    }
    // eslint-disable-next-line default-case
    switch (sizeBytesLength) {
      case 1:
        r.unshift.apply(r, Utils.decToInt8(r.length));
        break;
      case 2:
        r.unshift.apply(r, Utils.decToUint16le(r.length));
        break;
    }
  }
  return r;
};

Utils.decToUint64le = function (dec) {
  return [
    (dec >> 56) & 255,
    (dec >> 48) & 255,
    (dec >> 40) & 255,
    (dec >> 32) & 255,
    (dec >> 24) & 255,
    (dec >> 16) & 255,
    (dec >> 8) & 255,
    dec & 255,
  ];
};

// decimal -> uint32le -> uint8array
Utils.decToUint32le = function (dec) {
  return [(dec >> 24) & 255, (dec >> 16) & 255, (dec >> 8) & 255, dec & 255];
};

// decimal -> uint16le -> uint8array
Utils.decToUint16le = function (dec) {
  return [dec >> 8, dec & 255];
};

// decimal -> int16be -> uint8array
Utils.decToInt16 = function (dec) {
  return this.decToUint16le(dec).map(this.int8ToUint8);
};

// decimal -> int16be -> uint8array
Utils.decToInt32 = function (dec) {
  return this.decToUint32le(dec).map(this.int8ToUint8);
};

Utils.decToInt64 = function (dec) {
  return this.decToUint64le(dec).map(this.int8ToUint8);
};

Utils.uint8ToInt8 = function (val) {
  return (val << 24) >> 24;
};

Utils.int8ToUint8 = function (val) {
  return (val << 24) >>> 24;
};

Utils.boolToInt8 = function (val) {
  return [val ? 1 : 0];
};

Utils.decToInt8 = function (val) {
  return [val & 255];
};

Utils.toCamelCase = function (str) {
  return str.toLowerCase().replace(/[ _-]([a-z])/g, function (a, b) {
    return b.toUpperCase();
  });
};

/**
 * simple format string in java-way
 * @param  {String} str sting with placeholders
 * @param {...Object} objects to interpolate
 * @return {String} formated string
 *
 */
Utils.formatString = function (str) {
  const values = Array.prototype.slice.call(arguments, 1);
  let num = 0;
  return str.replace(/%((\d+)\$)?[sd]/g, function (match, p1, p2) {
    let v;
    if (!p2) {
      v = values[num];
      num++;
    } else {
      v = values[Number(p2) - 1];
    }
    return String(v);
  });
};

export default Utils;
